import { Alert } from '@designsforhealth/dfh-react-components'
import React, { useMemo } from 'react'
import type { UseFormMethods } from 'react-hook-form'
import styled from 'styled-components'

import { PractitionerSettings } from '../../../../../../lib/practitioner-settings/types'
import { inboundPatientShouldBeTrue } from '../../../../../../lib/practitioner-settings/utils'
import { ToggleProgress } from '../ToggleProgress'
import * as Styled from './styled'

const StyledAlert = styled(Alert)`
  && > div {
    margin: 15px 0 0;
  }
`

export interface VirtualDispensaryInboundPatientProps {
  className?: string
  control: UseFormMethods['control']
  isSubmitting: boolean
  register: UseFormMethods['register']
  settings: PractitionerSettings
}

const VirtualDispensaryInboundPatient: React.VFC<VirtualDispensaryInboundPatientProps> = ({
  className,
  control,
  isSubmitting,
  register,
  settings,
}) => {
  const { optedOutOfInboundPatient, optedOutOfDispensary } = settings.practitioner
  const isDefaultChecked = useMemo(
    () => inboundPatientShouldBeTrue({ optedOutOfDispensary, optedOutOfInboundPatient }),
    [optedOutOfDispensary, optedOutOfInboundPatient],
  )

  return (
    <div className={className}>
      <h3 className="small-h3">Patient Referral Program</h3>
      <Styled.Description>
        Enabling this feature allows DFH to display your virtual dispensary to new patient
        customers. Disabling it will opt you out of the Patient Referral Program.
      </Styled.Description>
      <Styled.Toggle
        id="inboundPatient"
        name="inboundPatient"
        control={control}
        register={register}
        defaultChecked={isDefaultChecked}
        disabled={isSubmitting || !!optedOutOfDispensary}
      >
        <Styled.Label>Patient referral program</Styled.Label>
        <ToggleProgress isSubmitting={isSubmitting} />
      </Styled.Toggle>
      {!!optedOutOfDispensary && (
        <StyledAlert type="attention">
          Patient Referral Program cannot be enabled while your Virtual Dispensary is disabled.
        </StyledAlert>
      )}
    </div>
  )
}

export default VirtualDispensaryInboundPatient
